import { List, Typography } from 'antd';
import { logo, MapMarkerIcon } from 'assets';
import { messages } from 'messages';
import React from 'react';
import { TicketDto } from 'types/dto/ticket';

type Props = {
  hasMore?: boolean;
  loading?: boolean;
  handleLoadMore?: () => void;
  data: TicketDto[];
  className?: string;
  showModal?: (ticketId: number, secondCall?: boolean) => void;
};

const ContactTicketList: React.FC<Props> = ({ data, hasMore, className, handleLoadMore, showModal }) => {
  return (
    <List
      dataSource={data}
      className={className}
      renderItem={(item) => <ContactTicketItem item={item} showModal={showModal} />}
    />
  );
};

const ContactTicketItem: React.FC<{
  item: TicketDto;
  showModal?: (ticketId: number, secondCall?: boolean) => void;
}> = ({ item, showModal }) => {
  return (
    <div
      className='mb-3 flex w-full cursor-pointer flex-col gap-1 border-b pb-3 transition-colors last:mb-0 hover:-ml-4 hover:-mt-1 hover:w-[calc(100%+32px)] hover:border-b-0 hover:bg-textHoverBg hover:px-4 hover:pt-[5px]'
      onClick={() => showModal && showModal(item.ticketId)}
    >
      <Typography.Paragraph
        className='mb-0 text-sm font-semibold'
        ellipsis={{
          rows: 1
        }}
      >
        {item.serviceType.name}
      </Typography.Paragraph>
      <Typography.Paragraph className='mb-0'>
        <span className='flex min-w-0 items-center'>
          <span className='mr-2 inline-block shrink-0'>
            <div className='h-4 w-4'>
              <img src={logo} className='h-full w-full' />
            </div>
          </span>
          <span className='shrink-0 whitespace-nowrap text-sm text-subTextColor2'>{item.customerCode}</span>
          <span className='mx-2 inline-block h-1 w-1 shrink-0 rounded-full bg-subTextColor' />
          <span className='mr-2 inline-block shrink-0'>
            <MapMarkerIcon className='h-4 w-4 text-[#b2b9c4]' />
          </span>
          <span className='truncate text-sm text-subTextColor2'>{item.customerRequestAddress}</span>
        </span>
      </Typography.Paragraph>
    </div>
  );
};

export default ContactTicketList;
